import { render, staticRenderFns } from "./SalonsForm.vue?vue&type=template&id=b29cfee8&"
import script from "./SalonsForm.vue?vue&type=script&lang=js&"
export * from "./SalonsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports